export default function arrayWrap<T>(item: Array<T> | T): Array<T> {
  if (item instanceof Array) {
    return item;
  }

  return [item];
}
